export enum Variant {
	OneOnOnesExperimental = 'one-on-ones-experimental',
	OneOnOnesR3FastFollows = 'achieve-adoption-r3-fast-follows',
	OpenOneOnOnes = 'open-one-on-ones',
	OneOnOnesFeedback = '1-1-feedback-popup',
	EmployeeSpotlight = 'employee-spotlight',
	EmployeeSpotlightTrigger = 'employee-spotlight-triggers',
	RemoveHomepageWidgetColumn = 'remove-homepage-widget-column',
	BizyConversationHistory = 'bizy_conversation_history',
	ConversationCatalyst = 'conversation-catalyst',
}
